"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAccount = exports.updateJobSubTypeV2 = exports.updateJobSubType = exports.removeJobImagesFromCustomerProfiles = exports.startNexusImportV2 = exports.setB2SWindow = exports.getJobWebConfig = exports.getAccountJobsV2 = exports.getAccountJobs = exports.getAccount = void 0;
const axios_1 = __importDefault(require("axios"));
const baseUrl = '/accounts-api';
async function getAccount(accountId) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/accounts/${accountId}`
    });
    return resp.data;
}
exports.getAccount = getAccount;
async function getAccountJobs(accountId) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/accounts/${accountId}/jobs`
    });
    return resp.data;
}
exports.getAccountJobs = getAccountJobs;
async function getAccountJobsV2(accountId) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/v2/accounts/${accountId}/jobs`
    });
    return resp.data;
}
exports.getAccountJobsV2 = getAccountJobsV2;
async function getJobWebConfig(accountCode, jobId) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/accounts/${accountCode}/jobs/${jobId}/webconfig`
    });
    return resp.data;
}
exports.getJobWebConfig = getJobWebConfig;
async function setB2SWindow(accountCode, jobId, data) {
    const resp = await (0, axios_1.default)({
        method: 'put',
        url: `${baseUrl}/accounts/${accountCode}/jobs/${jobId}/webconfig`,
        data
    });
    return resp.data;
}
exports.setB2SWindow = setB2SWindow;
async function startNexusImportV2(accountId, cloudJobId) {
    const resp = await (0, axios_1.default)({
        method: 'post',
        url: `${baseUrl}/v2/accounts/${accountId}/jobs/${cloudJobId}/nexus/import/start`
    });
    return resp.data;
}
exports.startNexusImportV2 = startNexusImportV2;
async function removeJobImagesFromCustomerProfiles(accountId, cloudJobId) {
    const resp = await (0, axios_1.default)({
        method: 'post',
        url: `${baseUrl}/v2/accounts/${accountId}/jobs/${cloudJobId}/images/remove-from-customers`
    });
    return resp.data;
}
exports.removeJobImagesFromCustomerProfiles = removeJobImagesFromCustomerProfiles;
async function updateJobSubType(accountId, jobId, jobSubType, oldJobSubType) {
    const resp = await (0, axios_1.default)({
        method: 'put',
        url: `${baseUrl}/accounts/${accountId}/jobs/${jobId}/jobsubtype`,
        data: { jobSubType, oldJobSubType }
    });
    return resp.data;
}
exports.updateJobSubType = updateJobSubType;
async function updateJobSubTypeV2(accountId, nexusJobId, jobSubType, oldJobSubType) {
    const resp = await (0, axios_1.default)({
        method: 'put',
        url: `${baseUrl}/v2/accounts/${accountId}/jobs/nexus/${nexusJobId}/jobsubtype`,
        data: { jobSubType, oldJobSubType }
    });
    return resp.data;
}
exports.updateJobSubTypeV2 = updateJobSubTypeV2;
async function deleteAccount(accountId, userId, updatedAt) {
    console.log('accountApi:deleteAccount', accountId, userId, updatedAt);
    const resp = await (0, axios_1.default)({
        method: 'delete',
        url: `${baseUrl}/accounts/${accountId}`,
        data: {
            accountId,
            userId,
            updatedAt
        }
    });
    console.log('accountApi:DeleteAccount:resp :', resp);
    return resp.data;
}
exports.deleteAccount = deleteAccount;
